<template>
	<ol class="flex items-center justify-center gap-x-1.5 gap-y-6 flex-wrap list-none">
		<li
			v-for="(breadcrumb, index) in breadcrumbs"
			:key="`breadcrumb-${breadcrumb.to.url}`"
			class="flex items-center gap-1.5"
		>
			<LazyAtomFontAwesome
				v-if="index > 0"
				icon="fa-arrow-right"
				class="w-4 text-purple-100/25"
			/>
			<AtomLink
				v-if="index + 1 < breadcrumbs.length"
				v-bind="breadcrumb.to"
				class="text-purple-100/50 hover:text-purple-100/75"
			>
				{{ breadcrumb.text }}
			</AtomLink>
			<strong
				v-else
				class="text-purple-100/75"
			>
				{{ breadcrumb.text }}
			</strong>
		</li>
	</ol>
</template>

<script setup lang="ts">
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';
import { formatSchema } from '#base/helpers/schemaHelpers';
import { urlFormatter } from '#base/helpers/urlHelpers';

const {
	breadcrumbs,
} = defineProps<{
	breadcrumbs: BreadcrumbsType;
}>();

useHead({
	script: [
		formatSchema({
			'@context': 'https://schema.org',
			'@type': 'BreadcrumbList',
			'itemListElement': breadcrumbs.map((breadcrumb, index) => ({
				'@type': 'ListItem',
				'position': index + 1,
				'item': {
					'@id': urlFormatter(breadcrumb.to.url),
					'name': breadcrumb.text,
				},
			})),
		}),
	],
});
</script>
